import React from 'react';

import { Control, SettingsItemWrapper } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import st from './SharedSubFormStyles.module.sass';

export const SaveToArchiveSubForm = ({ fieldName }) => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();

  const createFullName = (name) => (fieldName ? `${fieldName}.${name}` : name);
  const callbacksFieldName = createFullName('parameters.callbacks');
  const callbacksField = useWatch({ control, name: callbacksFieldName }) || [];
  const isActive = callbacksField.some((cb) => cb?.type === 'luna-event');

  const onChange = (e) => {
    const { checked } = e.target;
    const cbWithoutLunaEvent = callbacksField.filter((cb) => cb?.type !== 'luna-event');
    const updatedCallbacks = checked ? [...cbWithoutLunaEvent, { type: 'luna-event', enable: 1 }] : cbWithoutLunaEvent;

    setValue(callbacksFieldName, updatedCallbacks);
  };

  return (
    <SettingsItemWrapper
      className={st.SettingItem}
      contentClassName={st.SettingItem__Content}
      title={t('videoAnalytics:form.save_to_va_archive.label')}
      titleClassName={st.SettingItem__Title}
    >
      <Control.Checkbox
        checked={isActive}
        label={t(`videoAnalytics:form.${isActive ? 'enabled' : 'disabled'}`)}
        onChange={onChange}
      />
    </SettingsItemWrapper>
  );
};
